var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('bean-source-page',{attrs:{"type":_vm.type,"columns":_vm.columns,"form-columns":_vm.formColumns,"filter-columns":_vm.filterColumns,"actions":_vm.actions,"form":_vm.form,"title":_vm.$t('model.tradeRule'),"resource":"trade_rules"}})}
var staticRenderFns = []

export { render, staticRenderFns }